import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-our-challenges',
  templateUrl: './our-challenges.component.html',
  styleUrls: ['./our-challenges.component.scss']
})
export class OurChallengesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
